import { useContext } from 'react';
import { UsuarioContext } from '../../providers/personaContext';
import { CLAVE_GESTIONAR } from './api';

/**
 * ¿Puede esta sesión gestionar buzones, listas, licencias y correos secundarios? El mismo patrón
 * `can(clave)` de MenuPersonas: Super Administrador por bypass, el resto por la clave. Es sólo para
 * pintar o no los botones: la barrera de verdad es el servidor (`checkPermiso` en routes/rutas.js).
 */
export function usePuedeGestionarCorreos() {
  const ctx = useContext(UsuarioContext) || {};
  const esSuperAdmin = String(ctx.persona?.rol || '').toLowerCase() === 'super administrador';
  return esSuperAdmin || (Array.isArray(ctx.permisos) && ctx.permisos.includes(CLAVE_GESTIONAR));
}
